goog.provide("shadow.js.shim.module$src$svg$location$poi_svg$default");
shadow.js.shim.module$src$svg$location$poi_svg$default = shadow.js.shim.module$src$svg$location$poi_svg.default;
